import { useCallback, useMemo, useState } from "react";

import AscButton from "../../../..//AscButton/AscButton";
import AscFindTheWordsPuzzle from "../../../../AscFindTheWordsPuzzle/AscFindTheWordsPuzzle";

import styles from "./AscActivityFindwords.module.scss";
import {
  AdminFindWordsProps,
  AscFindTheWordsPuzzleWord,
} from "@ascendnow/shared";
import AscPuzzleQuestionAnswerForm from "../../../AscPuzzleQuestionAnswerForm/AscPuzzleQuestionAnswerForm";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";

export default function AscActivityFindWords() {
  const formik = useAscAddModuleActivitiesForm();

  const initForm = {
    answer: "",
    question: "",
  };

  const questionsInit = formik?.values?.findWord?.questions?.questions;

  const [questions, setQuestions] = useState(
    questionsInit?.length ? questionsInit : [initForm]
  );

  function handleQuestionChange(
    index: number,
    question: Partial<AdminFindWordsProps>
  ) {
    const newQuestions = [...questions];
    newQuestions[index] = { ...newQuestions[index], ...question };
    setQuestions(newQuestions);
  }

  const handleDelete = (index: number) => {
    const newQuestions = [...questions];
    newQuestions.splice(index, 1);
    if (newQuestions.length === 0) {
      newQuestions.push(initForm);
    }
    setQuestions(newQuestions);
  };

  const transformData = (
    words: AscFindTheWordsPuzzleWord[],
    questions: AdminFindWordsProps[]
  ) => {
    return words.map(({ word, ...rest }) => ({
      answer: word,
      question: questions?.find((q) => q?.answer === word)?.question,
      ...rest,
    }));
  };

  const handleOnGenerate = useCallback(
    (words: AscFindTheWordsPuzzleWord[], size: number) => {
      formik.setFieldValue(
        "findWord.questions.questions",
        transformData(words, questions)
      );
      formik.setFieldValue("findWord.questions.size", size);
    },
    [questions]
  );

  function addNewQuestion() {
    setQuestions([...questions, initForm]);
  }

  const isPuzzleEmpty = useMemo(() => {
    if (questions.length === 0) {
      return true;
    }
    if (questions?.every((w) => !w?.answer)) {
      return true;
    }
    return false;
  }, [questions]);

  const words = useMemo(() => {
    return questions?.map(({ answer }) => answer)?.filter((w) => !!w);
  }, [questions]);

  return (
    <div className={styles.ground}>
      <div className={styles.headerGround}>
        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={addNewQuestion}
        >
          Add question <span>+</span>
        </AscButton>
      </div>

      {questions.map((question, index: number) => (
        <AscPuzzleQuestionAnswerForm
          type="findWord"
          key={index}
          onChange={(question) => handleQuestionChange(index, question)}
          value={question}
          canDelete
          onDelete={() => handleDelete(index)}
        />
      ))}

      <AscFindTheWordsPuzzle
        mode="create"
        size={formik?.values?.findWord?.questions?.size}
        disabled={isPuzzleEmpty}
        words={words}
        onGenerate={handleOnGenerate}
      />
    </div>
  );
}
